import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import {jumpToUser} from 'src/helper/webviewFun'
import lang from '../lang'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  componentWillReceiveProps(e) {}

  render() {
    let { language, lang, members, setEditUsers } = this.props
    return (
      <div className="getUsers">
        <div
          className="title"
          onClick={() => {
            setEditUsers()
          }}
        >
          {lang.getUsers} <img src="/img/app/roomsupport/edit.png" className="edit" />
        </div>
        <div className="content">
          {(!members || members.length == 0) && (
            <div className="item">
              <img
                src={`/img/app/roomsupport/add.png`}
                className="logo"
                onClick={() => {
                  setEditUsers()
                }}
              />
              <div className="id"></div>
            </div>
          )}

          {members &&
            members.map((item, index) => {
              return (
                <div className="item" onClick={jumpToUser.bind(this, item.uid)}>
                  <img src={`${cdn(item.avatarurl)}`} className="logo" />
                  <div className="id">ID:{item.duid}</div>
                  {item.idx == 0 && (
                    <img src={`/img/app/roomsupport/owner.png`} className="owner" />
                  )}
                  {item.idx > 0 && <div className="num">{item.idx}</div>}
                </div>
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/GetUsers/index.js